import { render } from "./Permission.vue?vue&type=template&id=0840b523&scoped=true"
import script from "./Permission.vue?vue&type=script&lang=js"
export * from "./Permission.vue?vue&type=script&lang=js"

import "./Permission.vue?vue&type=style&index=0&id=0840b523&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0840b523"]])

export default __exports__